import Alfeu from '../img/codeguy.svg';

export default function About(){
    return(
        <section className='about'>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 55 1440 245"><path className='wave' fill="#ffffff" fillOpacity="1" d="M0,96L34.3,133.3C68.6,171,137,245,206,240C274.3,235,343,149,411,133.3C480,117,549,171,617,181.3C685.7,192,754,160,823,138.7C891.4,117,960,107,1029,117.3C1097.1,128,1166,160,1234,186.7C1302.9,213,1371,235,1406,245.3L1440,256L1440,0L1405.7,0C1371.4,0,1303,0,1234,0C1165.7,0,1097,0,1029,0C960,0,891,0,823,0C754.3,0,686,0,617,0C548.6,0,480,0,411,0C342.9,0,274,0,206,0C137.1,0,69,0,34,0L0,0Z"/></svg>
          <h3 className='sectionTitle' id='about'> {" Who I am ? (About me)"} </h3>
          <br/>
          <article className='about-me'>
            <div className='me-photo'>
              <img src={Alfeu} alt='Alfeu'/>
            </div>
            <div>
              <p>
                <b>Titles: </b>
                <i> Web Developer </i> ,<i> GDSC Lead </i>, <i> MOZDEVZ ambassador </i> and <i> CS & SE Student </i>
              </p>
              <p>
                <b>Languages: </b>
                <i>Portuguese(natively)</i>, <i>English(B1)</i> and <i>Spanish(A1)</i>. Have interest in Japanese and French.
              </p>
              <p>
                <b>Hobbies: </b>
                Writing, drawing, watching animes and singing in the shower 😅😅
              </p>
              <p>
                <b>Awards & Accomplishments: </b>
                Top 10 "Mozambican Sololearner" 2022, 
              </p>
              <p>
                <b>Other: </b>
                Self-taught, active attendee of developer communities such as MOZDEVZ, Maputo Frontenders, GDG Maputo, Python Community, GDSC's, Clube de TIC's in Secondary School & others.
              </p>
            </div>
          </article>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 132"><path className='wave2' fill="#3e6eff" transform="matrix(1.0001606,0,0,1.0001321,-0.62667878,-30.004226)" d="M 1440,32 C 977.22931,117.32339 713.91299,161.9177 1.8437364,161.94234 c -5.962223,2.1e-4 -1.93430982,-19.7 -1.90284027,-128.996677 L 0.29368877,163.94234 1440.7455,161.98284 Z"/></svg>
        </section>
    );
}